/**
 * DNS 管理相关类型定义
 */

/**
 * DNS 提供商类型
 */
export enum DNSProvider {
	CLOUDFLARE = 'cloudflare',
	DNSPOD = 'dnspod',
}

/**
 * DNS 记录类型
 */
export enum DNSRecordType {
	A = 'A',
	AAAA = 'AAAA',
	CNAME = 'CNAME',
	MX = 'MX',
	TXT = 'TXT',
	NS = 'NS',
	SRV = 'SRV',
	CAA = 'CAA',
}

/**
 * 域名信息
 */
export interface Domain {
	/** 域名ID */
	id: string;
	/** 域名 */
	name: string;
	/** DNS 提供商 */
	provider: DNSProvider;
	/** 状态 */
	status: 'active' | 'paused' | 'pending';
	/** 创建时间 */
	createdAt?: string;
	/** 修改时间 */
	modifiedAt?: string;
}

/**
 * DNS 记录
 */
export interface DNSRecord {
	/** 记录ID */
	id: string;
	/** 域名ID */
	domainId: string;
	/** 域名 */
	domainName: string;
	/** DNS 提供商 */
	provider: DNSProvider;
	/** 记录类型 */
	type: DNSRecordType;
	/** 主机记录（子域名） */
	name: string;
	/** 记录值 */
	content: string;
	/** TTL (秒) */
	ttl: number;
	/** 优先级 (仅 MX 记录) */
	priority?: number;
	/** 是否代理 (仅 Cloudflare) */
	proxied?: boolean;
	/** 创建时间 */
	createdAt?: string;
	/** 修改时间 */
	modifiedAt?: string;
	/** 备注 */
	comment?: string;
}

/**
 * 创建/更新 DNS 记录的请求参数
 */
export interface DNSRecordInput {
	/** 域名ID */
	domainId: string;
	/** DNS 提供商 */
	provider: DNSProvider;
	/** 记录类型 */
	type: DNSRecordType;
	/** 主机记录 */
	name: string;
	/** 记录值 */
	content: string;
	/** TTL */
	ttl: number;
	/** 优先级 (MX 记录) */
	priority?: number;
	/** 是否代理 (Cloudflare) */
	proxied?: boolean;
	/** 备注 */
	comment?: string;
}

/**
 * 获取域名列表响应
 */
export interface DomainsResponse {
	domains: Domain[];
}

/**
 * 获取 DNS 记录列表响应
 */
export interface DNSRecordsResponse {
	records: DNSRecord[];
}

/**
 * DNS 记录操作响应
 */
export interface DNSRecordResponse {
	record: DNSRecord;
}

/**
 * 批量删除 DNS 记录请求
 */
export interface BatchDeleteRecordsRequest {
	provider: DNSProvider;
	domainId: string;
	recordIds: string[];
}
